import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const UnsavedChangesDialog = ({ open, onConfirm, onCancel }) => (
  <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
    <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <WarningAmberIcon color="warning" />
      Unsaved Changes
    </DialogTitle>
    <DialogContent>
      <Typography>You have unsaved changes. Are you sure you want to close without saving?</Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel}>Keep Editing</Button>
      <Button onClick={onConfirm} color="error" variant="contained">Discard Changes</Button>
    </DialogActions>
  </Dialog>
);

export default UnsavedChangesDialog;
